import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    Text,
} from '@zillow/constellation';
import { Center, Row } from '@zillow/zrs-comet';

import TourCardSelectable from 'app/shared/components/postingPath/TourCardSelectable';

import { StyledEvenCol } from './StyledComponents';

const propTypes = {
    tours: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        createdDate: PropTypes.string.isRequired,
        creatorName: PropTypes.string.isRequired,
        imageSrc: PropTypes.string,
        src: PropTypes.string,
        state: PropTypes.oneOf(['active', 'inactive', 'empty']),
    })),
    onSelectTour: PropTypes.func.isRequired,
    onViewTour: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['floorplan', 'unit', 'amenity', 'singleFamily']),
    selectedTourId: PropTypes.string,
};

const defaultProps = {
    tours: [],
    mode: 'floorplan',
    selectedTourId: null,
};

const HELPER_TEXT = {
    floorplan: 'Select a tour to showcase this floor plan.',
    unit: 'Select a tour to showcase this unit.',
    singleFamily: 'Only one 3d tour can be selected per property.',
};

const ROW_SIZE = 2;

const SelectTourModal = ({
    tours,
    onSelectTour,
    onViewTour,
    mode,
    selectedTourId,
}) => {
    if (tours.length === 0) {
        return (
            <Center>
                <Text>There are no 3d tours associated with this listing</Text>
            </Center>
        );
    }

    const tourChunks = [];
    for (let i = 0; i < tours.length; i += ROW_SIZE) {
        tourChunks.push(tours.slice(i, i + ROW_SIZE));
    }

    return (
        <React.Fragment>
            {HELPER_TEXT[mode] && (
                <Text paddingBottom="xs" fontType="body" as="div">
                    {HELPER_TEXT[mode]}
                </Text>
            )}
            {tourChunks.map((tourChunk, chunkIndex) => (
                <Row paddingY="xs" key={`tour-row-${chunkIndex}`}>
                    {tourChunk.map((tour, tourIndex) => (
                        <StyledEvenCol
                            key={tour.id}
                            even={tourIndex % 2 === 0}
                            md={6}
                        >
                            <TourCardSelectable
                                tour={tour}
                                isSelected={tour.id === selectedTourId}
                                onView={() => onViewTour(tour)}
                                onSelect={() => onSelectTour(tour.id)}
                            />
                        </StyledEvenCol>
                    ))}
                </Row>
            ))}
        </React.Fragment>
    );
};

SelectTourModal.propTypes = propTypes;
SelectTourModal.defaultProps = defaultProps;

export { SelectTourModal };
export default connect()(SelectTourModal);
